import { useState } from "react";
import { useQuery } from "react-query";
import { useAuth } from "../../zustand/auth.store";
import Modal from "../Modal/Modal";
import PayoutInfoForm from "./PayoutInfoForm";
import { userServices } from "../../services/user";

// Shows a required, non-dismissable popup asking a member for their next of
// kin and Interac e-Transfer email once they've joined any pod (regardless
// of its status) and haven't submitted this info yet. AjoHomes only.
export default function PayoutInfoGate() {
  const profile = useAuth((s) => s.profile);
  const product = process.env.REACT_APP_PRODUCT_TYPE?.trim().toLowerCase();
  const [justSubmitted, setJustSubmitted] = useState(false);

  const { data } = useQuery(
    ["payout-info-status", profile?.id],
    () => userServices.payoutInfo.get(profile.id),
    { enabled: !!profile?.id && product === "ajohome" },
  );

  const isRequired = Boolean(data?.data?.required) && !justSubmitted;

  if (!isRequired) return null;

  return (
    <Modal open={true} showCloseButton={false}>
      <PayoutInfoForm
        userId={profile.id}
        onSuccess={() => setJustSubmitted(true)}
      />
    </Modal>
  );
}
